import script from "./ProfilePasswordResetStepTwoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePasswordResetStepTwoPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePasswordResetStepTwoPage.vue?vue&type=style&index=0&id=39a4f0b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39a4f0b8"]])

export default __exports__